import { defineStore } from "pinia";
import * as choiceApi from "../ChoiceApi"
import { IPatientFlagDisplayOrder, IPatientFlagPatientAssignItem } from "../Models/Setup/PatientFlagSetupModel";
import { DatabaseIdTypes } from "../../Enums/ChoiceEnums";

export const usePatientFlagsStore = defineStore('PatientFlagsStore', () => {
    // Cached values
    let cachedDisplayOrder: IPatientFlagDisplayOrder[] | undefined;

    async function getFlagDisplayOrder(forceReload?: boolean): Promise<IPatientFlagDisplayOrder[] | undefined>
    {
        if (undefined === cachedDisplayOrder || true === forceReload)
        {
            const displayOrder = (await choiceApi.patientFlagSetup.getUserFlagDisplayOrder());
            cachedDisplayOrder = displayOrder ?? [];
        }
        return cachedDisplayOrder;
    }

    async function saveUserFlagDisplayOrder(flagDisplayOrderValues: IPatientFlagDisplayOrder[]): Promise<void>
    {
        await choiceApi.patientFlagSetup.saveUserFlagDisplayOrder(flagDisplayOrderValues);
        cachedDisplayOrder = flagDisplayOrderValues;
    }

    async function getAssignedFlags(id: number, idType: DatabaseIdTypes): Promise<IPatientFlagPatientAssignItem[] | undefined>
    {
        return await choiceApi.patientFlagSetup.getAssignList(idType, id);
    }

    return { getFlagDisplayOrder, saveUserFlagDisplayOrder, getAssignedFlags };
});


